export const SET_USERID = 'SET_USERID'; //设置用户ID
export const SET_USER_INFO = 'SET_USER_INFO'; //设置用户信息
export const SET_CONVERSATION_USERID = 'SET_CONVERSATION_USERID'; //设置会话ID
export const SET_CURRENT_CONVERSATION = 'SET_CURRENT_CONVERSATION'; //设置当前会话
export const SET_CONVERSATION_STATUS = 'SET_CONVERSATION_STATUS'; //设置当前会话状态
export const SET_AUDIO_MESSAGEID = 'SET_AUDIO_MESSAGEID'; //设置语音消息ID
export const SET_FRIEND_ONLINE = 'SET_FRIEND_ONLINE'; //设置好友上线
export const SET_FRIEND_OFFLINE = 'SET_FRIEND_OFFLINE'; //设置好友下线
export const SET_CONVERSATION_LIST = 'SET_CONVERSATION_LIST'; //设置会话列表
export const ADD_CONVERSATION = 'ADD_CONVERSATION'; //添加会话对象
export const SEND_CHAT_MESSAGE = 'SEND_CHAT_MESSAGE'; //发送会话消息
export const ADD_HISTORY_MESSAGES = 'ADD_HISTORY_MESSAGES'; //添加历史消息
export const UPDATE_CHAT_MESSAGE = 'UPDATE_CHAT_MESSAGE'; //更新会话消息
export const UPDATE_LATEST_MESSAGE = 'UPDATE_LATEST_MESSAGE'; //更新最新消息

export const UPDATE_CONVERSATION_STATUS = 'UPDATE_CONVERSATION_STATUS'; //更新会话状态
export const UPDATE_CONVERSATION_STATUS_OTHER = 'UPDATE_CONVERSATION_STATUS_OTHER'; //收到更新会话状态



// WEBPACK FOOTER //
// ./src/store/mutation-types.js